import React, { useContext } from "react"
import { userPool } from "@project/shared"
import { useRouter } from "next/router"
import { useTranslation } from "react-i18next"
import Inquiry from "../../../public/assets/icons/inquiry.svg"
import UserManage from "../../../public/assets/icons/user_manage.svg"
import Home from "../../../public/assets/icons/home.svg"
import MerchantManage from "../../../public/assets/icons/merchant_manage.svg"
import AdminManage from "../../../public/assets/icons/admin_manage.svg"
import Logout from "../../../public/assets/icons/logout.svg"
import Event from "../../../public/assets/icons/event.svg"
import Product from "../../../public/assets/icons/product_management.svg"
import { AuthContext } from "../../../utils/AuthContext"
import { FileTextOutlined, GiftOutlined } from "@ant-design/icons"
import { SideBarComponent } from "@project/shared/src/components/organisms"
import { useQuery } from "react-query"
import { tenantDetail } from "../../../services"
import { notification } from "antd"
import { useIPRestriction } from "../../../hooks/useIPRestriction"

interface SideBarProps {
  children?: any
}
const SideBar: React.FC<SideBarProps> = ({ children }) => {
  const { t } = useTranslation()
  const loggedInUser = userPool.getCurrentUser()
  const { setUser, user, setIsSuperAdmin, setIsAdmin } = useContext(AuthContext)
  const { loading, checkTargetPageAccess } = useIPRestriction()
  const router = useRouter()

  const { data: tenant } = useQuery(
    ["tenantDetail", user?.["custom:tenantId"]],
    () => tenantDetail(Number(user?.["custom:tenantId"])),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      select: (data) => {
        return data?.["data"]
      },
      enabled: !!user?.["custom:tenantId"],
    }
  )

  const handleSignOut = async () => {
    setUser(null)
    setIsAdmin(false)
    setIsSuperAdmin(false)
    router.push("/login")
    loggedInUser.signOut()
  }

  // ページ遷移前のIP制限チェックを行う関数
  const handlePageNavigation = async (targetPath: string) => {
    // IP制限チェックがまだ完了していない場合は処理を中断
    if (loading) {
      notification.info({
        message: "処理中です",
        // description: "IP制限チェックを実行中です。少々お待ちください。",
        placement: "top",
      })
      return
    }
    // 遷移先ページのIP制限チェックを事前に実行
    const canAccessTargetPage = await checkTargetPageAccess(targetPath)

    if (!canAccessTargetPage) {
      notification.error({
        message: "アクセス権限がありません",
        // description: `このIPアドレスからはアクセスできません。`,
        placement: "top",
      })
      return
    }
    // クライアントサイドルーティングを使用して画面のちらつきを防ぐ
    router.push(targetPath)
  }

  const navItems = [
    {
      key: "home",
      icon: <Home />,
      label: t("Home"),
      onClick: () => handlePageNavigation("/home"),
    },
    {
      key: "resident",
      icon: <UserManage />,
      label: t("Resident management"),
      onClick: () => handlePageNavigation("/resident"),
    },
    {
      key: "transaction-list",
      icon: <FileTextOutlined />,
      label: t("Transaction List"),
      onClick: () => handlePageNavigation("/transaction-list"),
    },
    {
      key: "subsidy",
      icon: <GiftOutlined />,
      label: "給付金",
      onClick: () => handlePageNavigation("/subsidy"),
    },
    {
      key: "event-participation",
      icon: <Event />,
      label: t("event_participation"),
      onClick: () => handlePageNavigation("/event-participation"),
    },
    {
      key: "merchant-management",
      icon: <MerchantManage />,
      label: t("Merchant management"),
      onClick: () => handlePageNavigation("/merchant-management"),
    },
    {
      key: "product",
      icon: <Product />,
      label: t("Product management"),
      onClick: () => handlePageNavigation("/product"),
    },
    {
      key: "admin-management",
      icon: <AdminManage />,
      label: t("Admin management"),
      onClick: () => handlePageNavigation("/admin-management"),
    },
    {
      key: "inquiry",
      icon: <Inquiry />,
      label: t("Inquiry"),
      onClick: () => handlePageNavigation("/inquiry"),
    },
    {
      key: "logout",
      icon: <Logout />,
      label: t("Logout"),
      onClick: handleSignOut,
    },
  ]

  return (
    <SideBarComponent tenant={tenant} navItems={navItems} type={"admin"}>
      {children}
    </SideBarComponent>
  )
}
export { SideBar }
